var _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReHandshake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17584_44894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17584_44894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.6944 22 9.46181 21.7674 8.30208 21.3021C7.14236 20.8368 6.11458 20.191 5.21875 19.3646C4.32292 18.5382 3.59028 17.566 3.02083 16.4479C2.45139 15.3299 2.11111 14.125 2 12.8333H3.66667C3.77778 13.8333 4.04514 14.7674 4.46875 15.6354C4.89236 16.5035 5.44097 17.2708 6.11458 17.9375C6.78819 18.6042 7.5625 19.1424 8.4375 19.5521C9.3125 19.9618 10.25 20.2083 11.25 20.2917L9.95833 19L11.125 17.8333L14.875 21.5833C14.4028 21.7361 13.9271 21.8438 13.4479 21.9063C12.9687 21.9688 12.4861 22 12 22ZM20.3333 11.1667C20.2361 10.1667 19.9722 9.23264 19.5417 8.36458C19.1111 7.49653 18.559 6.72917 17.8854 6.0625C17.2118 5.39583 16.4375 4.85764 15.5625 4.44792C14.6875 4.03819 13.75 3.79167 12.75 3.70833L14.0417 5L12.875 6.16667L9.125 2.41667C9.59722 2.26389 10.0729 2.15625 10.5521 2.09375C11.0312 2.03125 11.5139 2 12 2C13.3056 2 14.5382 2.23264 15.6979 2.69792C16.8576 3.16319 17.8854 3.80903 18.7813 4.63542C19.6771 5.46181 20.4097 6.43403 20.9792 7.55208C21.5486 8.67014 21.8889 9.875 22 11.1667H20.3333Z",
    fill: "#888888"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7611 16.114L17 9.87505L15.7611 8.63611L10.7611 13.6361L8.23894 11.114L7 12.3529L10.7611 16.114Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReHandshake);
export default __webpack_public_path__ + "static/media/re-handshake.9d9bdb3ba25a9646acfce0667a154a5f.svg";
export { ForwardRef as ReactComponent };